import React from 'react';
import { Link } from 'react-router-dom';
import { Routes } from '../../../common/routes/routes';
import PropTypes from 'prop-types';
import { useSearchStore } from '../../../store/store';

export const OfficeNameLink = (props) => {
    const { data, value } = props;
    const { setSelectedBreakdownOffice } = useSearchStore(state => ({
        setSelectedBreakdownOffice: state.setSelectedBreakdownOffice,
    }));

    const handleClick = () => {
        setSelectedBreakdownOffice({ officeId: data.officeId, name: value });
    };

    return (
        <Link
            to={{
                pathname: `${Routes.MARKET_DYNAMICS.BASE}${Routes.MARKET_DYNAMICS.OFFICE_LISTING}`,
            }}
            onClick={handleClick}
        >
            {props.value}
        </Link>
    );
};

OfficeNameLink.propTypes = {
    data: PropTypes.object,
    value: PropTypes.string
};
